import VueColor from "vue-color";
export default {
  props: {
    value: {
      type: String,
      default: "#000000"
    }
  },
  data: function data() {
    return {
      color: this.value
    };
  },
  updated: function updated() {
    this.color = this.value;
  },
  components: {
    "sketch-picker": VueColor.Sketch
  },
  methods: {
    handleUpdate: function handleUpdate(e) {
      this.$emit("input", e.hex);
    }
  }
};